import { PropagandaModel } from 'model/api/gestao/propaganda/propaganda-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { VariaveisAmbiente } from 'config';

export function usePutAtualizarPropaganda() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putAtualizarPropaganda = useCallback(
        (propaganda: PropagandaModel) =>
            invocarApi({
                url: `/v1/Propagandas/${propaganda.id}`,
                method: 'PUT',
                data: propaganda,
                enviarTokenUsuario: true,
                baseURL: VariaveisAmbiente.apiPropaganda + '/api',
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        putAtualizarPropaganda,
    };
}
